'use client'

import { useRouter } from 'next/navigation'

import { Button, Pagination, Spin } from 'antd'
import { NoPhysiciansFoundMessage, PhysiciansList } from '@/src/components'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

import { QueryStringParams } from '@/src/interfaces'

type SearchResultsProps = {
  searchParams: QueryStringParams
  setSearchParams: (params: QueryStringParams) => void
  currentPage: number
  setCurrentPage: (page: number) => void
  total: number
  results: any
  loading: boolean
  geoLocation: {
    latitude: number
    longitude: number
  } | null
  loadingGeoLocation: boolean
}

export const SearchResults = ({
  searchParams,
  setSearchParams,
  currentPage,
  setCurrentPage,
  total,
  results,
  loading,
  geoLocation,
  loadingGeoLocation,
}: SearchResultsProps) => {
  const router = useRouter()

  const handlePaginationChange = (page: number, pageSize: number) => {
    const newParams = {
      ...searchParams,
      offset: (page - 1) * pageSize,
      limit: pageSize,
    }
    setCurrentPage(page)
    setSearchParams(newParams)
  }

  // Show loading state when either search or geolocation is loading
  const isLoading = loading || loadingGeoLocation

  // Only show no results message when we're not loading and there are no results
  const shouldShowNoResults = !isLoading && results.length === 0

  // Only show results when we have them and we're not loading
  const shouldShowResults = !isLoading && results.length > 0

  return (
    <div>
      {isLoading && (
        <div className='flex justify-center items-center min-h-[200px]'>
          <Spin size='large' />
        </div>
      )}
      {shouldShowNoResults && <NoPhysiciansFoundMessage />}
      {shouldShowResults && (
        <>
          <PhysiciansList results={results} geoLocation={geoLocation} />
          <div className='flex flex-col-reverse gap-16 md:flex-row md:gap-0 md:justify-between md:items-center'>
            <Button
              type='default'
              style={{
                height: 50,
                border: 'none',
                boxShadow: 'none',
              }}
              onClick={() => router.push('/home')}
            >
              <FontAwesomeIcon icon='arrow-left' />
              Back to Home
            </Button>
            <Pagination
              current={currentPage}
              defaultPageSize={Number(searchParams.limit)}
              total={total}
              align='end'
              pageSize={Number(searchParams.limit)}
              onChange={handlePaginationChange}
            />
          </div>
        </>
      )}
    </div>
  )
}
